import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showMenu: true, // 選單
    showComingModal: false, // 功能開放預告彈窗
    showLanguageModal: false, // 語言切換彈窗
    showUserModal: false, // user 資訊彈窗
    showNotifyModal: false, // user 通知彈窗
    showLoginModal: false, // 登入註冊彈窗
    showHintModal: false, // 提示小彈窗
    showComment: false, // 手機版留言
    showAdultConfirmModal: false, // 確認成年彈窗
    hintText: '', // 提示文字
    showLoginFailModal: false, // 黑名單登入失敗
};

export const popSlice = createSlice({
    name: 'pop',
    initialState,
    reducers: {
        setShowMenu: (state, actions) => {
            state.showMenu = actions.payload;
        },
        setShowComingModal: (state, actions) => {
            state.showComingModal = actions.payload;
        },
        setShowLanguageModal: (state, actions) => {
            state.showLanguageModal = actions.payload;
        },
        setShowUserModal: (state, actions) => {
            state.showUserModal = actions.payload;
        },
        setShowNotifyModal: (state, actions) => {
            state.showNotifyModal = actions.payload;
        },
        setShowLoginModal: (state, actions) => {
            state.showLoginModal = actions.payload;
        },
        setShowHintModal: (state, actions) => {
            state.showHintModal = actions.payload;
        },
        setHintText: (state, actions) => {
            state.hintText = actions.payload;
        },
        setShowMobileBottomMenu: (state, actions) => {
            state.showMobileBottomMenu = actions.payload;
        },
        setShowComment: (state, actions) => {
            state.showComment = actions.payload;
        },
        setShowAdultConfirmModal: (state, actions) => {
            state.showAdultConfirmModal = actions.payload;
        },
        setShowLoginFailModal: (state, actions) => {
            state.showLoginFailModal = actions.payload;
        },
    },
});

export const popState = (state) => state.pop;

export const {
    setShowMenu,
    setShowComingModal,
    setShowLanguageModal,
    setShowUserModal,
    setShowNotifyModal,
    setShowLoginModal,
    setShowHintModal,
    setHintText,
    setShowComment,
    setShowLoginFailModal,
} = popSlice.actions;

export default popSlice.reducer;
